import { AnchorLink } from 'components/anchorLink';
import { Icon, IconsEnum } from 'components/Icons';
import styles from './NoResult.module.scss';

export type NoResultProps = {
  label?: string;
  anchorLabel?: string;
  anchorHref?: string;
  noMargin?: boolean;
  transparent?: boolean;
  className?: string;
};

export const NoResult = ({
  label,
  anchorLabel,
  anchorHref,
  noMargin,
  transparent = false,
  className,
}: NoResultProps) => {
  return (
    <div
      className={`${styles.container} ${styles.flexCenter} ${noMargin ? '' : styles.margin} ${
        transparent ? styles.transparent : ''
      } ${className ? className : ''}`}
    >
      <div className={styles.flexCenter}>
        <Icon iconId={IconsEnum.SEARCH_OFF} className={styles.icon} color={'var(--color-on-bg-primary)'} />
        <p>{label}</p>
        {anchorLabel && anchorHref && (
          <AnchorLink href={anchorHref} className={styles.anchor}>
            {anchorLabel}
          </AnchorLink>
        )}
      </div>
    </div>
  );
};
